import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import {connect} from "react-redux";
import { patchUser } from 'redux/settings/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';
import TextAreaField
  from 'components/redux-form-adapters/TextAreaField';

import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';

import onClickOutside from 'react-onclickoutside';

import './AddUserDescription.css';

const ENTER_KEY = 13;

class AddUserDescription extends Component {
  static propTypes = {
    patchUser: PropTypes.func.isRequired,
    me: PropTypes.object,
    userDescription: PropTypes.string,
  };

  static defaultProps = {
    me: null,
    userDescription: null,
  };

  state = {
    initialValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);
    this.setState({ initialValue: this.props.me.description });
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  handleSubmit = () => {
    const { userDescription } = this.props;
    const { initialValue } = this.state;

    if (userDescription !== initialValue) {
      this.setState({ initialValue: userDescription});
      const form = new FormData();
      form.append('description', this.props.userDescription || '');
      this.props.patchUser(form);
    }
  };

  onEnterClick = event => {
    if (event.keyCode === ENTER_KEY) {
      this.handleSubmit();
    }
  };

  handleClickOutside = () => {
    this.handleSubmit();
  };

  render() {
    const { me } = this.props;
    const isLocked = me && me.subscription && !me.subscription.ff_description;

    return (
      <Translation>
        {(t) => (
          <ProSectionPlaceholder
            bordered={isLocked}
            key="add-user-description-pro-feature-key"
            className="add-user-description__component"
            locked={isLocked}
            text={
              <>
                {t("You can add description to your page on the PRO plan. Check it")}
              </>
            }
          >
            <Form onSubmit={this.handleSubmit}>
              <Field
                autoHeight
                component={TextAreaField}
                name="user_description"
                type="text"
                placeholder={t("Description")}
                markdown
                maxLength={500}
              />
            </Form>
          </ProSectionPlaceholder>
        )}
      </Translation>
    );
  }
}

const setInitialValues = params => {
  const _userDescription = params.description || '';
  return {
    user_description: _userDescription,
  };
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('AddUserDescription');
  return {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
    userDescription: selector(state, 'user_description'),
    initialValues: setInitialValues(state.usersReducer.me),
  };
};

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(reduxForm({
  form: 'AddUserDescription',
  enableReinitialize: true,
})(onClickOutside(AddUserDescription)));
